import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyC_Cqgu6ZqxHBjVtOjD25VINZXN4GZ6WGw",
    authDomain: "nfcmusica-18ea6.firebaseapp.com",
    projectId: "nfcmusica-18ea6",
    storageBucket: "nfcmusica-18ea6.firebasestorage.app",
    messagingSenderId: "1004129526672",
    appId: "1:1004129526672:web:d126e780b0c50121bf8915"
  };

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const analytics = getAnalytics(app);

export { db };
